"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlignHeaderColumns = void 0;
class AlignHeaderColumns {
    static init() {
        const breakpoint = window.matchMedia('(min-width:992px)');
        if (breakpoint.matches) {
            this.alignColumns();
        }
    }
    static alignColumns() {
        const columnsContent = document.querySelectorAll('section.column-header .column .inner-content');
        let maxHeight = 0;
        if (!columnsContent) {
            return;
        }
        columnsContent.forEach((content) => {
            content.clientHeight >= maxHeight ? (maxHeight = content.clientHeight) : null;
        });
        columnsContent.forEach((content) => {
            content.style.height = maxHeight + 'px';
        });
    }
}
exports.AlignHeaderColumns = AlignHeaderColumns;
